import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api.js';

const initialState = {
  collectors: [],
  uploadCollector: '',
  isUploading: false,
  failedRecords: [],
};

export const fetchCollectors = createAsyncThunk(
  'recordsPage/fetchCollectors',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/users/collectors');
      return response.data || [];
    } catch (error) {
      const message = error?.response?.data?.message || 'Could not fetch the list of collectors.';
      return rejectWithValue({ message });
    }
  }
);

export const uploadRecords = createAsyncThunk(
  'recordsPage/uploadRecords',
  async ({ file, collectorId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      if (collectorId) {
        formData.append('collectorId', collectorId);
      }

      const response = await api.post('/records/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data;
    } catch (error) {
      const message = error?.response?.data?.message || 'Upload failed';
      return rejectWithValue({ message });
    }
  }
);

const recordsPageSlice = createSlice({
  name: 'recordsPage',
  initialState,
  reducers: {
    setUploadCollector(state, action) {
      state.uploadCollector = action.payload;
    },
    setFailedRecords(state, action) {
      state.failedRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollectors.fulfilled, (state, action) => {
        state.collectors = action.payload;
      })
      .addCase(uploadRecords.pending, (state) => {
        state.isUploading = true;
        state.failedRecords = [];
      })
      .addCase(uploadRecords.fulfilled, (state, action) => {
        const { failedRecords = [] } = action.payload || {};
        state.isUploading = false;
        state.failedRecords = failedRecords;
      })
      .addCase(uploadRecords.rejected, (state) => {
        state.isUploading = false;
      });
  },
});

export const { setUploadCollector, setFailedRecords } = recordsPageSlice.actions;

export const selectRecordsPageCollectors = (state) => state.recordsPage.collectors;
export const selectRecordsPageUploadCollector = (state) => state.recordsPage.uploadCollector;
export const selectRecordsPageUploading = (state) => state.recordsPage.isUploading;
export const selectRecordsPageFailedRecords = (state) => state.recordsPage.failedRecords;

export default recordsPageSlice.reducer;
